<template>
  <div class="view-wrapper">
    <div class="botoes-topo-container elevation-2">
      <v-btn 
        class="botao-topo" 
        dark 
        :color="filtroProdutoAtivo ? 'primary' : '#7e91b4'" 
        @click="acaoFiltraProduto" 
        title="Todos os Produtos"
      >
        <v-icon>mdi-package-variant</v-icon> 
      </v-btn>

      <v-btn 
        class="botao-topo" 
        dark 
        :color="filtroDescontoAtivo ? 'primary' : '#7e91b4'" 
        @click="acaoFiltraPromo"
        title="Filtrar Promoções"
      >
        <v-icon>mdi-sale</v-icon>
      </v-btn>
    </div>

    <div class="search-container elevation-1 white px-3 pt-2 pb-2 d-flex flex-column">
      
      <v-radio-group 
        v-model="tipoBusca" 
        row 
        hide-details 
        class="mt-0 mb-3" 
        @change="aoMudarTipoBusca"
      >
        <v-radio label="Código" value="codigo" color="primary"></v-radio>
        <v-radio label="Descrição" value="descricao" color="primary"></v-radio>
      </v-radio-group>

      <div class="d-flex align-center" style="width: 100%;">
        <v-text-field
          ref="campoBusca"
          v-model="termoBusca"
          :label="labelBusca"
          outlined
          dense
          clearable
          hide-details
          class="mr-2"
        ></v-text-field>

        <v-btn 
          height="40"
          width="70"
          min-width="40"
          class="px-2 mr-2"
          color="primary" 
          elevation="2" 
          @click="forcarBusca('inicio')"
          title="Buscar pelo Início"
        >
          <v-icon>mdi-arrow-left-thick</v-icon>
        </v-btn>

        <v-btn 
          height="40"
          width="70"
          min-width="40"
          class="px-2"
          color="primary" 
          elevation="2" 
          @click="forcarBusca('qualquer')"
          title="Buscar em Qualquer Parte"
        >
          <v-icon>mdi-arrow-left-thick</v-icon><v-icon>mdi-arrow-right-thick</v-icon>
        </v-btn>
      </div>
    </div>

    <div class="content-container elevation-2">
      <div v-if="loading" class="text-center pa-8">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
        <p class="mt-4 mb-0 ">{{ textoLoading }}</p>
      </div>

      <div v-else-if="!loading && resultados.length === 0" class="text-center pa-8">
        <p class="mb-0">Nenhum resultado encontrado. De carga para ter resultados</p>
      </div>

      <RecycleScroller
        v-else
        ref="scrollerComponent"  class="scroller" 
        :items="resultados"
        :item-size="100" 
        :buffer="1000"  key-field="idcortamanhofinal"
        v-slot="{ item }"
      >
        <v-list-item
          class="list resultado-item-clicavel px-2"
          :class="{ 'item-selecionado': itemSelecionado === item }"
          style="height: 100px; border-bottom: 1px solid #e0e0e0;"
          v-intersect="{
            handler: (entries, observer, isIntersecting) => {
              if(isIntersecting) carregarImagemItem(item)
            }
          }"
        >
          <v-list-item-content>
            <v-list-item-title 
              class="dado-destacado3 font-weight-medium text-wrap text-justify" 
              style="height: auto; max-height: 48px; overflow: hidden; line-height: 1.2rem;"
            >
              {{ item.idcortamanhofinal }} - {{ item.descricao }}
            </v-list-item-title>
            
            <v-list-item-subtitle class="dado-destacado4">
              Marca: {{ item.marca }} |  
              Estoque: 
              <span> 
                {{ formatarDecimal(item.estoque, 2) }} 
              </span>
            </v-list-item-subtitle>

            <v-list-item-subtitle class="dado-destacado4 mt-1 d-flex align-center"> 
              <span>
                Preço: 
                <span v-if="item.promoAtiva && item.PrecoCombo" style="text-decoration: line-through; font-size: 0.85em; color: #9e9e9e;" class="mr-1">
                  {{ formatarMoeda(item.preco, 2) }}
                </span>
                
                <span :class="{'font-weight-bold text--darken-2': item.promoAtiva && item.PrecoCombo}">
                  {{ (item.promoAtiva && item.PrecoCombo) ? formatarMoeda(item.PrecoCombo, 2) : formatarMoeda(item.preco, 2) }}
                </span>
              </span>
              
              <v-btn 
                icon 
                small
                class="ml-0" 
                @click.stop="togglePrecoMinimo(item.idcortamanhofinal)"
              >
                <v-icon color="grey darken-1">
                  {{ precosMinimosVisiveis[item.idcortamanhofinal] ? 'mdi-eye-outline' : 'mdi-eye-off-outline' }}
                </v-icon>
              </v-btn>
              
              <span v-if="precosMinimosVisiveis[item.idcortamanhofinal]" class="ml-0">
                Mín.: {{ formatarMoeda(item.precoMinimo, 2) }}
              </span>
            </v-list-item-subtitle>

          </v-list-item-content>
          <div class="ml-2 d-flex flex-column align-center justify-space-between py-2" style="height: 100%;">
            <v-icon 
              v-if="!item.estoque || Number(item.estoque) <= 0" 
              color="red" 
              size="18"
              title="Estoque Zerado ou Negativo"
            >
              mdi-circle
            </v-icon>
            <div v-else style="height: 18px;"></div>
            <v-btn 
              small
              dark 
              color="primary" 
              class="ma-0" 
              @click.stop="acaoSugestaoItem(item)" 
              title="Sugestões/Similares"
              style="height: 26px; min-width: 36px; padding: 0 8px;"
            >
              <img :src="require('@/assets/hand-box.png')" alt="Sugestões" style="height: 16px; filter: brightness(0) invert(1);">
            </v-btn>
          </div>

          <v-list-item-avatar 
            tile 
            size="85" 
            class="my-0 ml-2 mr-1"
            :class="{ 'border-radius-circle': item.imagemUrl && !item.imagemCarregando }"
            style="cursor: pointer;"
            @click.stop="acaoCliqueImagem(item)"
          >
            <v-row v-if="item.imagemCarregando" class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular indeterminate color="primary" size="20"></v-progress-circular>
            </v-row>

            <v-img
              v-else-if="item.imagemUrl" 
              :src="item.imagemUrl" 
              contain 
              background-color="grey lighten-4"
            >
            </v-img>
          </v-list-item-avatar>

        </v-list-item>
      </RecycleScroller>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueVirtualScroller from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import db from '@/plugins/dexie';
import storage from '@/services/storage';

Vue.use(VueVirtualScroller)

export default {
  name: 'ViewCadastroPedidoProduto',
  
  data() {
    return {
      idPedido: this.$route.query.idpedido || null,
      idCliente: this.$route.query.idcliente || null,
      
      termoBusca: this.$route.query.busca || '',
      tipoBusca: this.$route.query.tipoBusca || 'descricao', 
      modoBusca: this.$route.query.modoBusca || 'qualquer',

      loading: false, 
      loadingInicial: true, 
      textoLoading: 'Carregando dados locais...',
      itemSelecionado: null,
      resultados: [], 
      filtroDescontoAtivo: this.$route.query.promo === '1', 
      filtroProdutoAtivo: this.$route.query.promo !== '1', 
      precosMinimosVisiveis: {},
      previousRouteName: null,
    };
  },

  beforeRouteEnter(to, from, next) {
    let originalFrom = from.name;
    if (from.name !== 'pesquisa-filtro-produto') {
      sessionStorage.setItem('indexProdutoOrigin', from.name);
      originalFrom = from.name;
    } else {
      originalFrom = sessionStorage.getItem('indexProdutoOrigin');
    }
    next(vm => {
      vm.previousRouteName = originalFrom;
    });
  },

  beforeRouteLeave(to, from, next) {
    if (this.$refs.scrollerComponent && this.$refs.scrollerComponent.$el) {
      const scrollPos = this.$refs.scrollerComponent.$el.scrollTop;
      sessionStorage.setItem('listaProdutosScrollPos', scrollPos);
    }

    if (to.name !== 'pesquisa-filtro-produto') {
      sessionStorage.removeItem('indexProdutoOrigin');
      storage.removeItem('filtro_produto_texto');
    }
    next();
  },

  watch: {
    '$route.query': {
      immediate: true,
      deep: true,
      handler(novoQuery, antigoQuery) {
        if (novoQuery.idpedido) this.idPedido = novoQuery.idpedido;
        if (novoQuery.idcliente) this.idCliente = novoQuery.idcliente;
        
        if (novoQuery.busca !== this.termoBusca) {
          this.termoBusca = novoQuery.busca || '';
        }

        if (!antigoQuery) {
          this.iniciarProcesso();
          return;
        }
        
        const mudouBusca = novoQuery.busca !== antigoQuery.busca;
        const mudouCategoria = novoQuery.idgrupo !== antigoQuery.idgrupo;
        const mudouTipo = novoQuery.tipoBusca !== antigoQuery.tipoBusca;
        const mudouModo = novoQuery.modoBusca !== antigoQuery.modoBusca;
        
        if (mudouBusca || mudouCategoria || mudouTipo || mudouModo) {
          this.iniciarProcesso();
        } 
        else if (novoQuery.selecionadoId !== antigoQuery.selecionadoId) {
          this.restaurarSelecaoDaUrl();
        }
      },
    },
  },

  computed: {
    veioDeTelaEspecifica() {
      return this.previousRouteName === 'cadastro-pedido-item';
    },
    labelBusca() {
      return this.tipoBusca === 'codigo' ? 'Buscar por Código' : 'Buscar por Descrição';
    }
  },

  methods: {
    focarInputBusca() {
      this.$nextTick(() => {
        if (this.$refs.campoBusca) {
          this.$refs.campoBusca.focus();
          const nativeInput = this.$refs.campoBusca.$el.querySelector('input');
          if (nativeInput) {
            nativeInput.select();
          }
        }
      });
    },

  aoMudarTipoBusca() {
    this.focarInputBusca();
    this.ordenarResultados();
  },

  ordenarResultados() {
    if (!this.resultados || this.resultados.length === 0) return;

    this.resultados.sort((a, b) => {
      if (this.tipoBusca === 'descricao') {
        const descA = (a.descricao || '').toString().toLowerCase();
        const descB = (b.descricao || '').toString().toLowerCase();
        return descA.localeCompare(descB);
      } else {
        const codA = (a.codigo || '').toString();
        const codB = (b.codigo || '').toString();
        return codA.localeCompare(codB, undefined, { numeric: true });
      }
    });
  },

    removerAcentos(texto) {
      if (!texto) return '';
      return texto.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
    },

    acaoCliqueImagem(item) {
      this.itemSelecionado = item;
      this.acaoDetalhe();
    },

    forcarBusca(modoSelecionado = null) {
      if (modoSelecionado) {
        this.modoBusca = modoSelecionado;
      }
      
      const query = { ...this.$route.query };
      const buscaLimpa = this.termoBusca ? this.termoBusca.trim() : '';

      if (buscaLimpa !== '') {
        query.busca = buscaLimpa;
        query.modoBusca = this.modoBusca;
      } else {
        delete query.busca;
        delete query.modoBusca;
      }

      query.tipoBusca = this.tipoBusca;

      if (this.$route.query.busca !== query.busca || 
          this.$route.query.tipoBusca !== query.tipoBusca ||
          this.$route.query.modoBusca !== query.modoBusca) {
        this.$router.replace({ query }).catch(() => {});
      } else {
        this.iniciarProcesso();
      }
    },

    async iniciarProcesso() {
      this.itemSelecionado = null;
      this.loading = true;
      this.loadingInicial = true; 

      await this.carregarPaginaVisualizacao();
      
      this.loadingInicial = false; 
      this.loading = false;

      this.restaurarPosicaoScroll();
    },

    restaurarPosicaoScroll() {
      const posSalva = sessionStorage.getItem('listaProdutosScrollPos');
      
      if (posSalva && this.resultados.length > 0) {
        this.$nextTick(() => {
          setTimeout(() => {
            const scroller = this.$refs.scrollerComponent;
            
            if (scroller && scroller.$el) {
              const posicao = parseInt(posSalva);
              
              scroller.$el.scrollTop = posicao;
              this.carregarImagensDaAreaVisivel(posicao);
            }
          }, 100);
        });
      } else {
        this.carregarImagensDaAreaVisivel(0);
        setTimeout(() => {
          this.carregarRestoEmBackground(0);
        }, 1000);
      }
    },

    carregarImagensDaAreaVisivel(scrollTopAtual) {
      if (!this.resultados.length) return;

      const scrollerEl = this.$refs.scrollerComponent ? this.$refs.scrollerComponent.$el : null;
      const alturaTela = scrollerEl ? scrollerEl.clientHeight : window.innerHeight;
      const alturaItem = 100;

      const indiceInicial = Math.floor(scrollTopAtual / alturaItem);
      
      const indiceFinal = Math.ceil((scrollTopAtual + alturaTela) / alturaItem) + 2;

      const inicioSeguro = Math.max(0, indiceInicial - 2);
      const fimSeguro = Math.min(this.resultados.length - 1, indiceFinal);

      for (let i = inicioSeguro; i <= fimSeguro; i++) {
        const item = this.resultados[i];
        if (item && !item.imagemUrl && !item.imagemCarregando) {
          this.carregarImagemItem(item);
        }
      }

      setTimeout(() => {
        this.carregarRestoEmBackground(fimSeguro + 1);
      }, 1000);
    },

    async carregarRestoEmBackground(indiceComeco) {
      const tamanhoLote = 5;

      if (indiceComeco >= this.resultados.length) return;

      const lote = this.resultados.slice(indiceComeco, indiceComeco + tamanhoLote);
      
      const promessas = lote.map(item => {
        if (item.imagemUrl || !item.temImagem || item.temImagem === 'N') return Promise.resolve();
        return this.carregarImagemItem(item);
      });

      await Promise.all(promessas);

      setTimeout(() => {
        this.carregarRestoEmBackground(indiceComeco + tamanhoLote);
      }, 100); 
    },

    acaoHistorico() {
      const query = this.$route.query;
      const clienteCodigo = this.idCliente || query.idcliente;
      const clienteNome = query.nomecliente || query.nome || ''; 

      this.$router.push({
        path: '/pesquisa-financeiro-cliente',
        query: { 
          aba: 'vendas', 
          clienteNome: clienteNome, 
          clienteCodigo: clienteCodigo,
        },
      });
    },
    
    async carregarPaginaVisualizacao() {
      try {
        const { busca, idgrupo, tipoBusca, modoBusca } = this.$route.query;
        const filtroGrupoId = idgrupo ? Number(idgrupo) : null;
        
        const filtroBusca = busca ? busca.toLowerCase().trim() : null;
        const tipoBuscaAtivo = tipoBusca || 'descricao';
        const modoBuscaAtivo = modoBusca || 'qualquer';

        let collection;

        if (filtroGrupoId) {
          collection = db.produto.where('idgrupo').equals(filtroGrupoId);
        } else {
          collection = db.produto.toCollection();
        }

        let produtos = await collection.toArray();

        produtos = produtos.filter(p => {
          const st = p.status || p.Status || p.STATUS;
          return st === 'A' || st === 'a';
        });

        if (filtroBusca || this.filtroDescontoAtivo) {
          produtos = produtos.filter(p => {
            let match = true;
            
            if (filtroBusca) {
              const termoBuscaAcento = this.removerAcentos(filtroBusca);

              if (tipoBuscaAtivo === 'descricao') {
                const desc = p.descricao ? this.removerAcentos(p.descricao.toLowerCase()) : '';
                if (modoBuscaAtivo === 'inicio') {
                  if (!desc.startsWith(termoBuscaAcento)) match = false;
                } else {
                  if (!desc.includes(termoBuscaAcento)) match = false;
                }
              } 
              else if (tipoBuscaAtivo === 'codigo') {
                const cod = p.codigointerno ? p.codigointerno.toString() : '';
                if (modoBuscaAtivo === 'inicio') {
                  if (!cod.startsWith(filtroBusca)) match = false;
                } else {
                  if (!cod.includes(filtroBusca)) match = false;
                }
              }
            }

            if (match && this.filtroDescontoAtivo) {
              const flagPromo = p.promocombo;
              if (!flagPromo || flagPromo === 'N' || flagPromo === 'null') {
                match = false;
              } else {
                const hoje = new Date();
                hoje.setHours(0,0,0,0);
                const dtInicio = new Date(p.datainiciopromocao || p.DataInicioPromocao);
                const dtFim = new Date(p.datafinalpromocao || p.DataFinalPromocao);
                if (!isNaN(dtInicio.getTime()) && !isNaN(dtFim.getTime())) {
                  if (hoje < dtInicio || hoje > dtFim) match = false;
                }
              }
            }
            return match;
          });
        }
        
        let mapaImagens = new Map();
        if (db.imagem) {
          const idsCtf = produtos.map(p => p.idcortamanhofinal).filter(id => id);
          if (idsCtf.length > 0) {
            const imagensLocais = await db.imagem.where('idcortamanhofinal').anyOf(idsCtf).toArray();
            mapaImagens = new Map(imagensLocais.map(img => [String(img.idcortamanhofinal), img]));
          }
        }

        this.resultados = produtos.map(p => this.mapearProdutoParaView(p, mapaImagens));
        this.ordenarResultados(); 
        
        this.restaurarSelecaoDaUrl();
        
        return true;

      } catch (e) {
        console.error("Erro load:", e);
        return false;
      }
    },

    mapearProdutoParaView(p, mapaImagens = null) {
      const dadosPromo = this.calcularTextoPromocao(p);
      const idReal = p.idcortamanhofinal || p.IdCortamanhofinal || p.idCortamanhofinal;
      let urlImagemGerada = null;

      if (mapaImagens) {
        const cache = mapaImagens.get(String(idReal));
        if (cache) {
          const blob = cache.imgBlob1 || cache.imgBlob2 || cache.imgBlob3;
          if (blob) {
            try {
              let blobParaSalvar = blob;
              if (!(blob instanceof Blob)) {
                blobParaSalvar = new Blob([blob], { type: 'image/jpeg' });
              }
              urlImagemGerada = URL.createObjectURL(blobParaSalvar);
            } catch (e) {
              console.error("Erro ao converter blob inicial:", e);
            }
          }
        }
      }

      return {
        idproduto: p.idproduto || p.idProduto, 
        idcortamanhofinal: idReal,
        codigo: p.codigointerno || p.codigoInterno,
        descricao: p.descricao,
        marca: p.marca,
        estoque: p.estoque,
        preco: p.preco,
        precoMinimo: p.precominico || p.precoMinimo,
        promocaoCombo:  p.promocombo,
        
        imagemUrl: urlImagemGerada, 
        imagemCarregando: false,
        
        temImagem: p.temImagem, 
        textoPromocao1: dadosPromo.titulo,
        textoPromocao2: dadosPromo.detalhe,
        promoAtiva: dadosPromo.promoAtiva,
        idGrupo: p.idgrupo || p.idGrupo,
        DataInicioPromocao: p.datainiciopromocao || p.DataInicioPromocao,
        DataFinalPromocao: p.datafinalpromocao || p.DataFinalPromocao,
        QtdeCombo: p.qtdecombo || p.QtdeCombo,
        CTFQtdeComboLeva: p.ctfqtdecomboleva || p.CTFQtdeComboLeva,
        PrecoCombo: p.precocombo || p.PrecoCombo,
      };
    },

    calcularTextoPromocao(produto) {
      const flagPromo = produto.promocombo || produto.promocaoCombo;
      
      if (!flagPromo || flagPromo === 'N' || flagPromo === 'null') {
        return { titulo: null, detalhe: null, promoAtiva: false };
      }
      const hoje = new Date();
      hoje.setHours(0,0,0,0);
      
      const dataInicio = new Date(produto.datainiciopromocao || produto.DataInicioPromocao);
      const dataFim = new Date(produto.datafinalpromocao || produto.DataFinalPromocao);
      
      if (!isNaN(dataInicio.getTime()) && !isNaN(dataFim.getTime())) {
        if (hoje < dataInicio || hoje > dataFim) {
            return { titulo: null, detalhe: null, promoAtiva: false };
        }
      }

      return { titulo: null, detalhe: null, promoAtiva: true };
    },

    async carregarImagemItem(item) {
      if (!item.temImagem || item.temImagem === 'N') {
        return;
      }
      if (item.imagemUrl || item.imagemCarregando) {
        return;
      }

      this.$set(item, 'imagemCarregando', true);

      try {
        if (db.imagem && item.idcortamanhofinal) {
          let cache = null;
          const idCtfNum = Number(item.idcortamanhofinal);
          if (!isNaN(idCtfNum)) {
            cache = await db.imagem.where('idcortamanhofinal').equals(idCtfNum).first();
          }
          if (!cache) {
            cache = await db.imagem.where('idcortamanhofinal').equals(String(item.idcortamanhofinal)).first();
          }
          
          
          if (cache) {
            const blobLocal = cache.imgBlob1 || cache.imgBlob2 || cache.imgBlob3;

            if (blobLocal) {
              const urlCache = URL.createObjectURL(blobLocal);
              this.$set(item, 'imagemUrl', urlCache);
              this.$set(item, 'imagemCarregando', false);
              return;
            }
          }
        }
      } catch (e) { 
        console.warn("Erro ao ler Dexie:", e); 
      }
      
      try {
        const idParaBusca = item.idcortamanhofinal;
        
        if (typeof this.fetchImagem === 'function') {
          const blob = await this.fetchImagem({ id: idParaBusca, indice: 1 });

          if (blob && (blob.size > 0 || blob.byteLength > 0)) {
            let blobParaSalvar = blob;
            if (!(blob instanceof Blob)) {
              blobParaSalvar = new Blob([blob], { type: 'image/jpeg' });
            }
            const urlCriada = URL.createObjectURL(blobParaSalvar);
            this.$set(item, 'imagemUrl', urlCriada);
            
            if (db.imagem && item.idcortamanhofinal) {
              let cache = null;
              const idCtfNum = Number(item.idcortamanhofinal);
              if (!isNaN(idCtfNum)) {
                cache = await db.imagem.where('idcortamanhofinal').equals(idCtfNum).first();
              }
              if (!cache) {
                cache = await db.imagem.where('idcortamanhofinal').equals(String(item.idcortamanhofinal)).first();
              }

              if (cache) {
                await db.imagem.where('id').equals(cache.id).modify({
                  imgBlob1: blobParaSalvar,
                  dataDownloadImagem: new Date()
                });
              } else {
                await db.imagem.add({
                  idproduto: item.idproduto,
                  idcortamanhofinal: item.idcortamanhofinal,
                  imgBlob1: blobParaSalvar,
                  dataDownloadImagem: new Date()
                });
              }
            }
          } else {
            this.$set(item, 'imagemUrl', null); 
          }
        } else {
          this.$set(item, 'imagemUrl', null);
        }
      } catch (error) {
        console.error('Erro ao buscar imagem online:', error);
        this.$set(item, 'imagemUrl', null);
      } finally {
        this.$set(item, 'imagemCarregando', false);
      }
    },

    async verificarRetornoStorage() {
      const retornoStr = sessionStorage.getItem('retornoSelecaoProduto');
      if (retornoStr) {
        try {
          sessionStorage.removeItem('retornoSelecaoProduto');
        } catch (e) { console.error(e); }
      }
    },

    acaoSugestaoItem(item) {
      if (!item) return;
      this.$router.push({
        path: '/pesquisa-filtro-produto',
        query: { 
            aba: 'sugestao',
            idGrupo: item.idGrupo, 
            produtoNome: item.descricao,
            produtoCodigo: item.codigo
        },
      });
    },
    acaoDetalhe() {
      if (!this.itemSelecionado) return;
      this.$router.push({
        path: '/pesquisa-filtro-produto',
        query: { 
          aba: 'detalhamento',
          produtoNome: this.itemSelecionado.descricao, 
          produtoId: this.itemSelecionado.idcortamanhofinal 
        },
      });
    },

    acaoFiltraProduto() {
      if (this.filtroProdutoAtivo) return;
      
      this.filtroProdutoAtivo = true;
      this.filtroDescontoAtivo = false;
      const query = { ...this.$route.query };
      if (query.promo) {
        delete query.promo;
        this.$router.replace({ query }).catch(() => {});
      }
      this.iniciarProcesso();
    },

    acaoFiltraPromo() {
      if (this.filtroDescontoAtivo) return;
      
      this.filtroDescontoAtivo = true;
      this.filtroProdutoAtivo = false;
      const query = { ...this.$route.query, promo: '1' };
      this.$router.replace({ query }).catch(() => {});
      this.iniciarProcesso();
    },
    
    togglePrecoMinimo(idProduto) {
      const estadoAtual = this.precosMinimosVisiveis[idProduto] || false;
      this.$set(this.precosMinimosVisiveis, idProduto, !estadoAtual);
    },

    toggleSelecao(item) {
      const novoItem = (this.itemSelecionado === item) ? null : item;
      this.itemSelecionado = novoItem;
      const query = { ...this.$route.query };
      if (novoItem) {
        query.selecionadoId = novoItem.idcortamanhofinal;
      } else {
        delete query.selecionadoId;
      }
      this.$router.replace({ query }).catch(() => {});
    },

    restaurarSelecaoDaUrl() {
      const { selecionadoId } = this.$route.query;
      if (selecionadoId && this.resultados.length > 0) {
        const idParaSelecionar = parseInt(selecionadoId);
        const itemEncontrado = this.resultados.find(p => p.idcortamanhofinal === idParaSelecionar);
        if (itemEncontrado) this.itemSelecionado = itemEncontrado;
      }
    },
    
    formatarMoeda(valor) {
      if (!valor) return '0,00';
      return valor.toLocaleString('pt-BR', { 
        minimumFractionDigits: 2, 
        maximumFractionDigits: 2 
      });
    },
    formatarDecimal(valor, casas = 3) {
      if (typeof valor !== 'number') return '0';
      return valor.toLocaleString('pt-BR', { minimumFractionDigits: casas, maximumFractionDigits: casas });
    },
  },

  mounted() {
    if (!this.loadingInicial) {
      this.verificarRetornoStorage();
    }
  }
};
</script>

<style scoped>
.view-wrapper {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 56px);
}
.content-container {
  width: 100%;
  flex-grow: 1;
  overflow: hidden;
  position: relative;
}
.botoes-topo-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 0;
  width: 100%;
  background-color: white;
  flex-shrink: 0;
} 

.scroller {
  height: 100%;
  overflow-y: auto;
}
.scroller::-webkit-scrollbar {
  width: 12px;
}
.scroller::-webkit-scrollbar-thumb {
  background: rgba(76, 111, 175, 0.4);
  border-radius: 4px;
}
.scroller::-webkit-scrollbar-thumb:hover {
  background-color: #ccc;
}

.item-selecionado {
  background-color: #E3F2FD !important;
}
.botao-topo {
  flex-grow: 1;
  margin: 0 4px;
}
.dado-destacado {
  color: #1976D2;
  font-size: 0.78rem;
}
.dado-destacado2 {
  font-size: 0.78rem;
}

.dado-destacado4 {
  font-size: 0.90rem;
}

.dado-destacado3 {
  font-size: 1rem;
}
.icon-img {
  height: 24px;
  width: 24px; 
  filter: brightness(0) invert(1);
}
.list{
  background-color: white;
}
.border-radius-circle{
  border: #ccc 1px solid;
}

::v-deep .v-input--radio-group__input {
  display: flex;
  width: 100%;
}
::v-deep .v-radio {
  margin-right: 16px !important;
}
</style>